// components/navbar/Navbar.jsx

import ThemeToggle from "../ui/ThemeToggle";
import MobileBottomNav from "./MobileBottomNav";

import DownloadCVButton from "./DownloadCVButton";
import NavLinks from "./NavLinks";
import NavbarContainer from "./NavbarContainer";
import ScrollProgress from "./ScrollProgress";

export default function Navbar() {

    return (
        <>
            <NavbarContainer>

                <div className="flex gap-10 items-center">

                    <div
                        data-aos="fade-left"
                        data-aos-duration="1000"
                    >
                    </div>

                    <NavLinks />

                </div>

                <div
                    className="md:hidden w-full flex justify-between gap-4"
                    data-aos="fade-right"
                    data-aos-duration="1000"
                >
                    <DownloadCVButton />
                    <ThemeToggle />
                </div>

                <div
                    className="hidden md:flex gap-6"
                    data-aos="fade-down"
                    data-aos-duration="1000"
                >
                    <DownloadCVButton />
                    <ThemeToggle />
                </div>

                <MobileBottomNav />

            </NavbarContainer>

            <ScrollProgress />
        </>
    );
}